import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import React, { FormEvent } from "react";
import { theme } from "src/styles/theme";
import * as Styled from "../Steps/stylesStepTab";
import InputText from "@components/Sales/Inputs/InputText";
import InputSelect from "@components/Sales/Inputs/InputSelect";
import {
  optionCommercialRegionalSP,
  optionTypeSale,
} from "@helpers/optionSelect";
import InputSelectSearch from "@components/Sales/Inputs/InputSelectSearch";
import { formatDatePtBr } from "@helpers/format";
import { IAccordionComponent } from "src/@types/Sales";
import { optionBroker } from "./options";
import InputTextEdit from "@components/Sales/Inputs/InputTextEdit";

const AccordionComponent = ({
  formik,
  edit,
  typeSale,
  setTypeSale,
  mainCampaign,
  setMainCampaign,
  selectMainCampaign,
  setSelectMainCampaign,
  loadingCampaign,
  fallReason,
  setFallReason,
  selectMainEnterprises,
  setSelectMainEnterprises,
  mainEnterprises,
  setMainEnterprises,
  loadingMainEnterprise,
  handleGetEnterprises,
  getEnterprises,
  handleGetCampaign,
  getCampaign,
  commercialRegional,
  setCommercialRegional,

  broker,
  setBroker,
  selectBroker,
  setSelectBroker,
  dataBroker,
  getBroker,
  loadingBroker,
  setIdBroker,
  regional,
  existCommercialRegional,
  isEditConsultor,
}: IAccordionComponent) => {
  const tipoDeUsuario: any = localStorage.getItem("@tipoDeUsuario");

  const renderedOptionsBroker = optionBroker(
    dataBroker,
    selectBroker,
    setSelectBroker,
    setBroker,
    setIdBroker,
  );

  const handleChangeMoneyDiscount = (
    event: React.ChangeEvent<HTMLInputElement> | FormEvent<HTMLInputElement>,
  ) => {
    let inputValue = (event.target as HTMLInputElement).value;

    inputValue = inputValue.replace(/\D/g, "");

    const numericValue = Number(inputValue) / 100;

    const formattedValue = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(numericValue);

    return { numericValue, formattedValue };
  };

  return (
    <Accordion allowMultiple>
      <AccordionItem mt={"10px"} borderRadius={8}>
        <AccordionButton
          bg={
            regional === "SP" && !commercialRegional
              ? theme.error50
              : theme.disable100
          }
          _hover={{
            bg: regional === "SP" && !commercialRegional && theme.error50,
          }}
          borderRadius={8}
          h={"50px"}
        >
          <Box
            as="span"
            flex="1"
            textAlign="left"
            fontWeight={"bold"}
            fontSize={"18px"}
          >
            Informações da oportunidade
          </Box>
          <AccordionIcon />
        </AccordionButton>

        <AccordionPanel pb={4}>
          <Styled.ContainerBoxInputs>
            <InputText
              isRequirement
              readOnly
              name={"idOportunity"}
              label="ID da oportunidade:"
              placeholder="ID da oportunidade"
              value={formik.values.idOportunity}
            />
            <InputText
              readOnly
              name={"creatorOportunity"}
              label="Criador da oportunidade:"
              placeholder="Criador da oportunidade"
              value={formik.values.creatorOportunity}
            />
            <InputText
              readOnly
              name={"dateSale"}
              label="Data da venda:"
              placeholder="__/__/___"
              value={formatDatePtBr(formik.values.dateSale)}
            />
            <InputText
              readOnly
              name={"dateClosing"}
              label="Data de fechamento:"
              placeholder="__/__/___"
              value={formatDatePtBr(formik.values.dateClosing)}
            />
            <InputText
              isRequirement
              readOnly
              name={"dateOportunity"}
              label="Data da oportunidade:"
              placeholder="__/__/___"
              value={formatDatePtBr(formik.values.dateOportunity)}
            />

            <InputSelect
              readOnly={!edit}
              title="Tipo de venda:"
              label={typeSale || "Selecione uma opção"}
              isSelected={typeSale}
              options={optionTypeSale}
              selectedOption={typeSale}
              onChange={(e) => setTypeSale(e.currentTarget.value)}
            />

            <InputText
              isRequirement
              readOnly
              label="Nome da oportunidade:"
              name="nameOportunity"
              value={formik.values.nameOportunity}
            />

            <InputText
              isRequirement
              readOnly
              label="Imobiliária:"
              name="realEstate"
              value={formik.values.realEstate}
            />

            {tipoDeUsuario !== "Gerente" || tipoDeUsuario !== "Coordenador" ? (
              <InputText
                isRequirement
                readOnly
                label="Contato consultor(a):"
                name="contactConsultant"
                value={formik.values.contactConsultant}
              />
            ) : ((tipoDeUsuario === "Gerente" ||
                tipoDeUsuario === "Coordenador") &&
                isEditConsultor) ||
              broker === "" ||
              broker === null ? (
              <InputSelectSearch
                disabled={!edit}
                isRequirement
                isOportunity
                width="22%"
                height="18%"
                title="Contato consultor(a):"
                placeholder="Pesquise por corretor"
                value={selectBroker}
                onChangeInput={(e) => setSelectBroker(e.target.value)}
                isSelected={broker}
                onChangeIcon={() => {
                  setBroker("");
                  setSelectBroker("");
                }}
                onClickSearchIcon={getBroker}
                loading={loadingBroker}
              >
                {renderedOptionsBroker}
              </InputSelectSearch>
            ) : (
              <InputSelectSearch
                disabled={!edit || !isEditConsultor}
                isRequirement
                isOportunity
                width="22%"
                height="18%"
                title="Contato corretor:"
                placeholder="Pesquise por corretor"
                value={selectBroker}
                onChangeInput={(e) => setSelectBroker(e.target.value)}
                isSelected={broker}
                onChangeIcon={() => {
                  setBroker("");
                  setSelectBroker("");
                }}
                onClickSearchIcon={getBroker}
                loading={loadingBroker}
              >
                {renderedOptionsBroker}
              </InputSelectSearch>
            )}

            {regional !== "SP" || commercialRegional === "DF" ? (
              <InputText
                isRequirement
                readOnly
                label="Regional Comercial:"
                name="commercialRegional"
                value={commercialRegional}
              />
            ) : (
              <InputSelect
                readOnly={existCommercialRegional || !edit}
                isRequirement
                title="Regional Comercial:"
                label={commercialRegional || "Selecione uma opção"}
                isSelected={commercialRegional}
                options={optionCommercialRegionalSP}
                selectedOption={commercialRegional}
                onChange={(e) => setCommercialRegional(e.currentTarget.value)}
                error={regional === "SP" && !commercialRegional}
              />
            )}

            <InputText
              isRequirement
              readOnly
              label="Empreendimento:"
              name="enterprise"
              value={formik.values.enterprise}
            />

            <InputText
              isRequirement
              readOnly
              label="Produto:"
              name="product"
              value={formik.values.product}
            />

            <InputText
              isRequirement
              readOnly
              label="Unidade de negócio:"
              name="businessUnit"
              value={formik.values.businessUnit}
            />

            <InputText
              isRequirement
              readOnly
              label="Status do contrato:"
              name="statusContract"
              value={formik.values.statusContract}
            />

            <InputText
              isRequirement
              readOnly
              label="Valor:"
              name="value"
              value={formik.values.value}
            />

            <InputText
              isRequirement
              readOnly
              label="Valor contrato:"
              name="valueContract"
              value={formik.values.valueContract}
            />

            <InputText
              isRequirement
              readOnly
              label="Valor real da venda:"
              name="realValueSale"
              value={formik.values.realValueSale}
            />

            <InputText
              isRequirement
              readOnly
              label="Fase:"
              name="fase"
              value={formik.values.fase}
            />

            <InputSelect
              readOnly={!edit}
              title="Motivo da queda:"
              label={fallReason || "Selecione uma opção"}
              isSelected={fallReason}
              options={[]}
              selectedOption={fallReason}
              onChange={(e) => setFallReason(e.currentTarget.value)}
            />

            <InputTextEdit
              readOnly={!edit}
              name={"awardFolder"}
              label="Pasta premiada:"
              value={formik.values.awardFolder}
              onChange={(e) => {
                const { formattedValue } = handleChangeMoneyDiscount(e);
                formik.handleChange(e);
                formik.setFieldValue("awardFolder", formattedValue);
              }}
            />
          </Styled.ContainerBoxInputs>
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem mt={"10px"} borderRadius={8}>
        <AccordionButton bg={theme.disable100} borderRadius={8} h={"50px"}>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            fontWeight={"bold"}
            fontSize={"18px"}
          >
            Produto de interesse
          </Box>
          <AccordionIcon />
        </AccordionButton>

        <AccordionPanel pb={4}>
          <Styled.ContainerBoxInputsSearch>
            <InputSelectSearch
              disabled={!edit}
              title="Emp. de interesse principal:"
              placeholder="Pesquise por empreendimento"
              value={selectMainEnterprises}
              onChangeInput={(e) => setSelectMainEnterprises(e.target.value)}
              isSelected={mainEnterprises}
              onChangeIcon={() => {
                setMainEnterprises("");
                setSelectMainEnterprises("");
              }}
              onClickSearchIcon={handleGetEnterprises}
              loading={loadingMainEnterprise}
            >
              {getEnterprises}
            </InputSelectSearch>

            <InputText
              readOnly
              name={"enterpriseWeb"}
              label="Emp. Interesse Web:"
              placeholder="Emp. Interesse Web"
              value={formik.values.enterpriseWeb}
            />

            <InputSelectSearch
              disabled={!edit}
              title="Origem da campanha principal:"
              placeholder="Pesquise por campanha"
              value={selectMainCampaign}
              onChangeInput={(e) => setSelectMainCampaign(e.target.value)}
              isSelected={mainCampaign}
              onChangeIcon={() => {
                setMainCampaign("");
                setSelectMainCampaign("");
              }}
              onClickSearchIcon={handleGetCampaign}
              loading={loadingCampaign}
            >
              {getCampaign}
            </InputSelectSearch>
          </Styled.ContainerBoxInputsSearch>
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem mt={"10px"} borderRadius={8}>
        <AccordionButton bg={theme.disable100} borderRadius={8} h={"50px"}>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            fontWeight={"bold"}
            fontSize={"18px"}
          >
            Informações do SAFI
          </Box>
          <AccordionIcon />
        </AccordionButton>

        <AccordionPanel pb={4}>
          <Styled.ContainerBoxInputs>
            <InputText
              readOnly
              label="FID:"
              name="Fid"
              value={formik.values.Fid}
            />

            <InputText
              readOnly
              label="Status SAFI:"
              name="statusSafi"
              value={formik.values.statusSafi}
            />

            <InputText
              readOnly
              label="Justificativa:"
              name="justification"
              value={formik.values.justification}
            />

            <InputText
              readOnly
              label="Data de assinatura:"
              name={"signatureDate"}
              value={formik.values.signatureDate}
            />

            <InputText
              readOnly
              label="Venda futura:"
              name={"futureSale"}
              value={formik.values.futureSale === false ? "Não" : "Sim"}
            />

            <InputText
              readOnly
              label="SICAQ:"
              name={"sicaq"}
              value={formik.values.sicaq}
            />

            <InputText
              readOnly
              label="Etapa SAFI:"
              name="stageSafi"
              value={formik.values.stageSafi}
            />
          </Styled.ContainerBoxInputs>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default AccordionComponent;
